<template>
  <el-card id="secondary">
    <div class="main clearfloat marginT20">
      <div class="templateBox left">
        <img
          class="phoneImg"
          :src="require('@/assets/imges/standard/airCleaner/airFilter.png')"
          alt
        />
      </div>
      <!-- 箭头块 -->
      <div class="iconBox left">
        <i class="el-icon-right iconRight" style="margin-top: 66px"></i>
        <i class="el-icon-right iconRight" style="margin-top: 270px"> </i>
      </div>
      <!-- 配置块 -->
      <div class="configBox left">
        <!-- 页面配置 -->
        <el-form ref="form" :rules="rules" :model="form" label-width="110px">
          <!-- 背景图片 -->
          <el-form-item label="封面" prop="shopImage">
            <div class="phoneBox">
              <el-upload
                ref="bg"
                class="bgImg-uploader"
                action="useless"
                :show-file-list="false"
                :limit="1"
                accept=".png"
                :http-request="handleChoseFile"
              >
                <img v-if="displayImgUrl" :src="displayImgUrl" class="bgImg" />
                <i v-else class="el-icon-plus bgImg-uploader-icon"></i>
              </el-upload>
              <div style="color:red;">
                支持扩展名：.PNG； 尺寸要求：依据ui给定数值展示；
              </div>
            </div>
          </el-form-item>
          <!-- 购买链接 -->
          <el-form-item label="购买链接" prop="shopUrl">
            <el-input
              size="small"
              style="width: 300px"
              class="btnConfigInput"
              v-model="form.shopUrl"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="group-btns">
          滤芯详情
          <div
            v-for="(item, index) in form.airFilerElements"
            :key="index"
            class="btns"
          >
            <!-- 操作 -->
            <div class="btn-operation">
              <span class="btn-span">{{ "滤芯" + (index + 1) }}</span>
              <div>
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="handleDelete(i, index)"
                ></el-button>
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="index == 0"
                  icon="el-icon-top"
                  @click="handleMove('up', index)"
                ></el-button>
                <el-button
                  size="mini"
                  type="primary"
                  :disabled="index == form.airFilerElements.length - 1"
                  icon="el-icon-bottom"
                  @click="handleMove('down', index)"
                ></el-button>
              </div>
            </div>
            <!-- 配置 -->
            <div>
              <!-- 名称 -->
              <el-upload
                :ref="'active' + index"
                :show-file-list="false"
                action="#"
                class="uploadicon"
                accept=".png"
                :limit="1"
                :http-request="file => handleChoseFile1(file, index)"
              >
                <i
                  class="el-icon-plus icon-container"
                  v-if="!item.activeImage"
                ></i>
                <img
                  :src="createImage(item.activeImage)"
                  v-else
                  class="img-container"
                />
              </el-upload>
              <el-upload
                :ref="'inactive' + index"
                :show-file-list="false"
                action="#"
                class="uploadicon"
                accept=".png"
                :limit="1"
                :http-request="file => handleChoseFile2(file, index)"
              >
                <i
                  class="el-icon-plus icon-container"
                  v-if="!item.inactiveImage"
                ></i>
                <img
                  :src="createImage(item.inactiveImage)"
                  v-else
                  class="img-container"
                />
              </el-upload>
              <el-input
                size="small"
                class="input-width"
                placeholder="功能名称"
                v-model="item.name"
              />
              <el-input
                size="small"
                class="input-width"
                placeholder="功能描述"
                v-model="item.desc"
              />
              <el-input
                size="small"
                class="input-width"
                placeholder="按钮名称"
                v-model="item.btnName"
              />
              <!-- 类型 -->
              <el-select v-model="item.type" size="small" class="input-width">
                <el-option
                  v-for="type in types"
                  :key="type.value"
                  :value="type.value"
                  :label="type.label"
                ></el-option>
              </el-select>
              <!-- 页面 type == 2 -->
              <el-select
                v-model="item.secondImageId"
                class="input-width"
                v-if="item.type == 2"
                size="small"
                @change="
                  val => {
                    handleChangePageType(index, val);
                  }
                "
              >
                <el-option
                  v-for="page in pages"
                  :key="page.id"
                  :value="page.id"
                  :label="handlePageName(page)"
                ></el-option>
              </el-select>
              <!-- 属性 type == 1 -->
              <el-select
                v-model="item.propertyId"
                class="input-width"
                v-if="item.type == 1"
                size="small"
              >
                <el-option
                  v-for="type in propertes"
                  :key="type.id"
                  :value="type.id"
                  :label="type.propertyName"
                ></el-option>
              </el-select>
              <!-- 外链 type == 3 -->
              <el-input
                size="small"
                class="input-width"
                v-model="item.linkUrl"
                v-if="item.type == 3"
              ></el-input>
              <!-- 弹窗 type == 5 -->
              <el-select
                v-model="item.secondImageId"
                class="input-width"
                v-if="item.type == 5"
                size="small"
                @change="
                  val => {
                    handleChangePageType(index, val);
                  }
                "
              >
                <el-option
                  v-for="page in pages"
                  :key="page.id"
                  :value="page.id"
                  :label="handlePageName(page)"
                ></el-option>
              </el-select>
            </div>
          </div>
        </div>
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handleAddBtn"
          >滤芯</el-button
        >
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: ["propertes", "productId", "pageInfo", "pages"],
  data() {
    return {
      dialogVision: false,
      form: {
        shopImage: "",
        shopUrl: "",
        type: 20,
        airFilerElements: []
      },
      types: [
        {
          value: 1,
          label: "属性"
        },
        {
          value: 2,
          label: "页面"
        },
        {
          value: 3,
          label: "外链"
        },
        {
          value: 5,
          label: "弹窗"
        }
      ],
      rules: {
        shopUrl: [
          {
            required: true,
            message: "请输入购买链接",
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    if (Array.isArray(this.pages)) {
      let filterRow = this.pages.filter(el => {
        return el.type == 20;
      })[0];
      if (filterRow) {
        this.form = {
          ...filterRow,
          airFilerElements: filterRow.airFilerElements || []
        };
      }
    }
  },
  computed: {
    displayImgUrl() {
      return this.form.shopImage
        ? this.$store.state.standard.fileLoad + this.form.shopImage
        : "";
    }
  },
  methods: {
    createImage(fileName) {
      return fileName ? this.$store.state.standard.fileLoad + fileName : "";
    },
    // 移动按钮
    handleMove: function(fun, idx) {
      let list = this.$utils.handleMoveArr(
        this.form.airFilerElements,
        fun,
        idx
      );
      this.$set(this.form, "airFilerElements", list);
    },
    handleDelete: function(index) {
      this.form.airFilerElements.splice(index, 1);
    },
    // 修改按钮指向页面时
		handleChangePageType: function (index, val) {
			for (let i in this.pages) {
				if (this.pages[i].id == val) {
					this.form.airFilerElements[index].pageType = this.pages[i].type;
				}
			}
		},
    // 当修改页面类型时
		handleChangeBtnType: function (idx, val) {
			let list = Object.assign([], this.form.airFilerElements);
			list[idx].secondImageId = "";
			list[idx].propertyId = "";
			list[idx].linkUrl = "";
			list[idx].pageType = "";
			this.$set(this.form, "airFilerElements", list);
		},
    handleAddBtn() {
      this.form.airFilerElements.push({
        activeImage: "",
        inactiveImage: "",
        name: "",
        desc: "",
        btnName: ""
      });
    },
    handleSubmit() {
      return this.form;
    },
    handleChoseFile(param) {
      const formData = new FormData();
      formData.append("files", param.file);
      this.$http.uploadFiles(formData).then(res => {
        if (res.data.success) {
          this.form.shopImage = res.data.data.toString();
          this.$refs.bg.clearFiles();
        }
      });
    },
    handleChoseFile1(param, index) {
      const formData = new FormData();
      formData.append("files", param.file);
      this.$http.uploadFiles(formData).then(res => {
        if (res.data.success) {
          this.form.airFilerElements[index].activeImage = res.data.data.toString();
          this.$refs['active' + index][0].clearFiles();
        }
      });
    },
    handleChoseFile2(param, index) {
      const formData = new FormData();
      formData.append("files", param.file);
      this.$http.uploadFiles(formData).then(res => {
        if (res.data.success) {
          this.form.airFilerElements[index].inactiveImage = res.data.data.toString();
          this.$refs['inactive' + index][0].clearFiles();
        }
      });
    },
    // 转译页面名称
    handlePageName: function(page) {
      let type = this.$utils.escapePageName(page.type);
      let nvgName = page.nvgName;
      if (page.inner) {
        return type;
      } else {
        return nvgName + "-" + type;
      }
    }
  }
};
</script>

<style scoped lang="less">
.templateBox {
  width: 280px;
}
.iconRight {
  display: block;
  font-size: 28px;
}

.phoneImg {
  width: 280px;
  height: 500px;
}
.configBox {
  border: 1px solid #ccc;
  width: calc(100% - 350px);
  border-radius: 5px;
  padding: 20px;
  min-height: 478px;
}
.btnConfigInput {
  width: 180px;
}
.group-btns {
  position: relative;
  margin-bottom: 16px;
  .btn-group-operation {
    position: absolute;
    top: 0;
    right: 0;
  }
  .btns {
    position: relative;
    .btn-operation {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 8px 0;
      .btn-span {
        font-size: 12px;
      }
    }
  }
}
.uploadicon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #666;
  font-size: 12px;
  margin-right: 8px;
  border: 1px dashed #d9d9d9;
  width: 28px;
  height: 28px;
  .icon-container {
    width: 28px;
    height: 28px;
    line-height: 28px;
  }
  .img-container {
    width: 28px;
    height: 28px;
    font-size: 0;
    display: inline-block;
    vertical-align: -10px;
    line-height: 0;
  }
}
.input-width {
  width: 150px;
  margin-right: 8px;
  margin-bottom: 8px;
}
</style>
